
import { hfw_logo } from "@assets/svg";
import { Bars3Icon } from "@heroicons/react/20/solid";
import { useNavigate } from "@remix-run/react";
import React, { useEffect, useState } from "react";
import SidebarLayout from "../../pages/public/home/mobile/sidebar-layout";
import PopUpMobile from "../../pages/public/home/mobile/assessment-pop";
import { classNames } from "@utilities";
import { HeaderProps } from "@models/ui";
import NotificationsSidebar from "../../pages/public/home/mobile/notifications-sidebar";
import { BrowserCustomerClient } from "@client";
import { NotificationEventMessage } from "@models/api";

const HeaderMobile: React.FC<{ headerProps: HeaderProps }> = ({ headerProps }) => {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [notificationSidebarOpen, setNotificationSidebarOpen] = useState(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);    

    // const [notificationsCount, setNotificationsCount] = useState<number>(notifications.length);
    const [notifications, setNotifications] = useState<NotificationEventMessage[]>([]);
    useEffect(() => {
        let intervalId: ReturnType<typeof setInterval>;

        if (!headerProps.isLoggedIn) {
            return
        }

        (async () => {

            intervalId = setInterval(async () => {
                const client = new BrowserCustomerClient();
                const initialNotificationsResp = await client.GetNotifications();
                const initialNotifications = initialNotificationsResp.data;
                // console.log('Received initial notifications:', initialNotifications);
                setNotifications(initialNotifications);
            }, 5000);

        })();

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const handleLogoClick = () => {
        localStorage.setItem("position", "header");
        navigate("/")
    }
    const handlePopupClose = () => {
        setIsOpen(false);
    };

    return (
        <div className="loader-opacity-header-mobile w-full px-5 py-4 flex gap-x-2 justify-between fixed top-0 left-0 z-10 bg-white shadow-md">
            <button onClick={handleLogoClick}>
                <img src={hfw_logo} alt="brand_logo" className="w-[138px] h-[28px]" />
            </button>
            <div className="flex gap-x-4">
                {
                    notifications.length !== 0 ?
                        <svg onClick={() => setNotificationSidebarOpen(true)} xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                            <path d="M14.8749 22.4999C14.8749 22.732 14.7827 22.9546 14.6186 23.1187C14.4545 23.2827 14.232 23.3749 13.9999 23.3749H6.99999C6.76792 23.3749 6.54537 23.2827 6.38128 23.1187C6.21718 22.9546 6.125 22.732 6.125 22.4999C6.125 22.2679 6.21718 22.0453 6.38128 21.8812C6.54537 21.7171 6.76792 21.625 6.99999 21.625H13.9999C14.232 21.625 14.4545 21.7171 14.6186 21.8812C14.7827 22.0453 14.8749 22.2679 14.8749 22.4999ZM20.7646 19C20.6128 19.2674 20.3924 19.4895 20.1261 19.6433C19.8598 19.7971 19.5573 19.8771 19.2498 19.875H1.75006C1.44243 19.8746 1.14035 19.7931 0.874255 19.6387C0.608164 19.4843 0.387469 19.2625 0.234412 18.9957C0.0813563 18.7288 0.00134839 18.4264 0.00245268 18.1187C0.00355698 17.8111 0.0857346 17.5092 0.240703 17.2435C0.847726 16.1978 1.75006 13.2404 1.75006 9.37512C1.75006 7.05451 2.67192 4.82895 4.31284 3.18802C5.95376 1.5471 8.17933 0.625244 10.4999 0.625244C12.8205 0.625244 15.0461 1.5471 16.687 3.18802C18.328 4.82895 19.2498 7.05451 19.2498 9.37512C19.2498 13.2393 20.1532 16.1978 20.7603 17.2435C20.9168 17.5096 20.9996 17.8126 21.0002 18.1213C21.0007 18.43 20.9191 18.7333 20.7635 19H20.7646ZM19.2498 18.125C18.4044 16.6736 17.4998 13.318 17.4998 9.37512C17.4998 7.51863 16.7624 5.73818 15.4496 4.42544C14.1369 3.11271 12.3564 2.37522 10.4999 2.37522C8.64345 2.37522 6.86299 3.11271 5.55026 4.42544C4.23752 5.73818 3.50003 7.51863 3.50003 9.37512C3.50003 13.3191 2.59442 16.6747 1.75006 18.125H19.2498Z" fill="black" />
                            <circle cx="17.0002" cy="5" r="3.5" fill="#FF5757" stroke="white" />
                        </svg>
                        :
                        <svg onClick={() => setNotificationSidebarOpen(true)} xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24" fill="none">
                            <path d="M14.8746 22.4997C14.8746 22.7318 14.7824 22.9543 14.6184 23.1184C14.4543 23.2825 14.2317 23.3747 13.9996 23.3747H6.99974C6.76768 23.3747 6.54512 23.2825 6.38103 23.1184C6.21694 22.9543 6.12475 22.7318 6.12475 22.4997C6.12475 22.2676 6.21694 22.0451 6.38103 21.881C6.54512 21.7169 6.76768 21.6247 6.99974 21.6247H13.9996C14.2317 21.6247 14.4543 21.7169 14.6184 21.881C14.7824 22.0451 14.8746 22.2676 14.8746 22.4997ZM20.7644 18.9997C20.6126 19.2672 20.3922 19.4893 20.1259 19.6431C19.8596 19.7969 19.5571 19.8769 19.2496 19.8747H1.74981C1.44218 19.8743 1.1401 19.7928 0.874011 19.6384C0.60792 19.4841 0.387224 19.2623 0.234168 18.9954C0.0811122 18.7286 0.00110425 18.4261 0.00220854 18.1185C0.00331284 17.8109 0.0854904 17.509 0.240458 17.2432C0.847481 16.1976 1.74981 13.2401 1.74981 9.37488C1.74981 7.05427 2.67167 4.8287 4.31259 3.18778C5.95351 1.54686 8.17908 0.625 10.4997 0.625C12.8203 0.625 15.0459 1.54686 16.6868 3.18778C18.3277 4.8287 19.2496 7.05427 19.2496 9.37488C19.2496 13.239 20.153 16.1976 20.76 17.2432C20.9165 17.5093 20.9993 17.8123 20.9999 18.121C21.0005 18.4298 20.9188 18.7331 20.7633 18.9997H20.7644ZM19.2496 18.1248C18.4041 16.6734 17.4996 13.3178 17.4996 9.37488C17.4996 7.51839 16.7621 5.73794 15.4494 4.4252C14.1366 3.11246 12.3562 2.37498 10.4997 2.37498C8.6432 2.37498 6.86275 3.11246 5.55001 4.4252C4.23728 5.73794 3.49979 7.51839 3.49979 9.37488C3.49979 13.3189 2.59418 16.6745 1.74981 18.1248H19.2496Z" fill="black" />
                        </svg>
                }

                <button type="button" className={classNames("-m-2.5 p-2.5 text-gray-700", sidebarOpen ? "hidden" : "")} onClick={() => setSidebarOpen(true)}>
                    <span className="sr-only">Open sidebar</span>
                    <Bars3Icon className="h-8 w-8" aria-hidden="true" />
                </button>
                {isOpen && <PopUpMobile isPopupOpen={isOpen} onPopupClose={handlePopupClose} />}

                {
                    notificationSidebarOpen ?
                        <NotificationsSidebar notifications={notifications} sidebarOpen={notificationSidebarOpen}
                            setSidebarOpen={setNotificationSidebarOpen} setPopupOpen={setIsOpen} customerImageUrl={headerProps.customerImageUrl} customerName={headerProps.customerName} />
                        :
                        ""
                }
                {
                    sidebarOpen ?
                        <SidebarLayout sidebarOpen={sidebarOpen}
                            setSidebarOpen={setSidebarOpen} setPopupOpen={setIsOpen} headerProps={headerProps} />
                        :
                        ""
                }
            </div>
        </div>
    )
}

export default HeaderMobile;
